/* eslint-disable no-magic-numbers */
import { isToday, isTomorrow, format, getHours } from 'date-fns';

import { GetBiteTimePreview } from '../../interfaces/graphql';

function getTimeRange(hour: number): string {
  if (hour < 6) {
    return '12AM - 6AM';
  }
  if (hour < 12) {
    return '6AM - 12PM';
  }
  if (hour < 18) {
    return '12PM - 6PM';
  }
  return '6PM - 12AM';
}

function getTimeFrame(datetime: string): string {
  const date = new Date(datetime);
  const timeRange = getTimeRange(getHours(date));

  if (isToday(date)) {
    return `${timeRange} Today`;
  }
  if (isTomorrow(date)) {
    return `${timeRange} Tomorrow`;
  }
  return `${timeRange} ${format(date, 'cccc')}`;
}

export function getBiteTimeSummary({ speciesForecastPreview }: GetBiteTimePreview): {
  timeframe: string;
  rating: string;
} {
  if (!speciesForecastPreview) {
    return {
      rating: 'No data available',
      timeframe: '',
    };
  }

  const { rating, readingAt } = speciesForecastPreview;
  return {
    rating,
    timeframe: rating === 'Poor' ? 'Next 24 hours' : getTimeFrame(readingAt),
  };
}
